import type { Slide } from '@features/powerpoint';
import type { BuildPresentationV2Props } from './build-presentation';
import { overviewSlideInterfaceV2 } from '../../../../slides/overview-slide-interface-v2';
import { formatters } from '@utils/formattersV2';

export const overviewSlideFromPropsV2 = (
  props: BuildPresentationV2Props,
  slideMaster: string
): Slide[] =>
  props.customFields.includedSlides.overall.overview
    ? [
        overviewSlideInterfaceV2({
          flightDates: [
            props.data.campaign.startDate,
            props.data.campaign.endDate,
          ],
          measurementDates: [
            props.data.campaign.startDate,
            props.data.selectedReportDate,
          ],
          metrics: [
            {
              name: 'Impressions',
              value: formatters.number(props.data.report.impressions, {
                full: true,
              }),
            },
            {
              name: 'Users Matched for Attribution',
              value: formatters.number(
                props.data.report.matchedForAttribution,
                { full: true }
              ),
            },
            {
              name: 'Unique Users',
              value: formatters.number(props.data.report.uniqueUsers, {
                full: true,
              }),
            },
            {
              name: 'Unique Retailer Banners',
              value: formatters.number(props.data.report.retailerBanners, {
                full: true,
              }),
            },
            {
              name: 'Media Spend',
              value: formatters.currency(props.data.campaign.adSpend, {
                full: true,
                decimals: 0,
              }),
            },
          ],
          reportsIncluded: ['Sales Lift', 'Performance by Retailer'],
          reportingDimensions: props.data.report.dimensions.map(
            dimension => dimension.dimensionName
          ),
          slideMaster,
        }),
      ]
    : [];
